export default (data) => (data.code ? `${data.code} - ${data.name}` : data.name) || '';
